(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  window.addEventListener('load', function() {
    let button = document.getElementsByClassName("close-button");
    button[button.length - 1].addEventListener("click", () => {
      button[button.length - 1].parentNode.setAttribute("style", "display:none");
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', function() {
    const looks = document.querySelectorAll(".shopify-section--shop-the-look");
    for(let i = 0; i < looks.length; i++){
      if(i === 0) {
        looks[i].style.display = "block";
      }else {
        looks[i].style.display = "none";
      }
    }

    const btns = document.querySelectorAll(".tabs-nav__button");
    for(let j = 0; j < btns.length; j++){
      btns[j].index = j;
      btns[j].onclick = function () {
        for(let i = 0; i < looks.length; i++){
          if(i === this.index) {
            looks[i].style.display = "block";
          }else {
            looks[i].style.display = "none";
          }
        }
      }
    }

    const s_btns = document.querySelectorAll(".accordion");
    for(let k = 0; k < s_btns.length; k++){
      s_btns[k].removeAttribute("open");
      s_btns[k].setAttribute("aria-expanded", false);
      s_btns[k].index = k;
      s_btns[k].onclick = function () {
        for(let i = 0; i < looks.length; i++){
          if(i === this.index) {
            looks[i].style.display = "block";
            this.removeAttribute("open");
            this.setAttribute("aria-expanded", false);
          }else {
            looks[i].style.display = "none";
            this.removeAttribute("open");
            this.setAttribute("aria-expanded", false);
          }
        }
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
